<template>
	<div>
		<div class="h4 mb-3">Sign In</div>
		<b-form @submit.prevent="signIn(email.toLowerCase(), password)">
			<b-form-group id="input-group-1">
				<b-input id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Email" v-model="email"></b-input>
			</b-form-group>
			<b-form-group id="input-group-1">
				<b-input id="inline-form-input-username" placeholder="Password" type="password" v-model="password"></b-input>
			</b-form-group>
			<b-form-group id="input-group-4">
				<b-button class="w-100" variant="primary" type="submit">Sign In</b-button>
			</b-form-group>
		</b-form>
		<div class="alert alert-danger" role="alert" v-if="signInError">
			<strong>Whoops!</strong> {{ signInError }}
		</div>
		<!--<div class="small"><router-link to="/forgot-password" class="text-white" style="text-decoration: underline;">Forgot your password</router-link></div>-->
	</div>
</template>

<script>
	export default {
		name: 'SignIn',
		data () {
			return {
				email: '',
				password: '',
				signInError: false
			}
		},
		methods: {
			signIn (email, password) {
				this.signInError = false;
				this.$store.dispatch('auth/authenticate', {
					strategy: 'local',
					email,
					password
				})
				.then(() => {
					this.$router.push('/');
				}).catch(err => {
					this.signInError = err.message;
				});
			}
		}
	}
</script>
